import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import crossTabSync from './cross-tab-sync';
import storage from 'redux-persist/lib/storage';

import {
	authReducer,
	commonReducer,
	settingsReducer,
	tasksReducer,
} from './reducers';

const rootPersistConfig = {
	key: 'root',
	storage,
	whitelist: ['auth', 'locked', 'autoLock'],
};

const settingsPersistConfig = {
	key: 'settings',
	storage,
	whitelist: ['rowsPerPage', 'licenseSettings'],
};

const tasksReducerPersistConfig = {
	key: 'tasks',
	storage,
	whitelist: ['tasks'],
};

const commonPersistConfig = {
	key: 'common',
	storage,
	whitelist: ['isExpandedSidebar'],
};

const reducers = combineReducers({
	auth: persistReducer(rootPersistConfig, authReducer),
	common: persistReducer(commonPersistConfig, commonReducer),
	settings: persistReducer(settingsPersistConfig, settingsReducer),
	tasks: persistReducer(tasksReducerPersistConfig, tasksReducer),
});

export const store = createStore(
	reducers,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
export const persistor = persistStore(store);

crossTabSync(store);
